import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, Renderer2, HostListener } from '@angular/core';
import { ChartData, OnGoingData } from '../../models/operations_persona';

@Component({
  selector: 'app-ongoingtask',
  templateUrl: './ongoingtask.component.html',
  styleUrls: ['./ongoingtask.component.scss'],
  standalone: false,
})
export class OngoingtaskComponent {
  @Input() statusData: OnGoingData[] = [];
  @Input() onGoingChart: ChartData = <ChartData>{};
  @Output() statusEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('toggleButton') toggleSpan: ElementRef;
  @ViewChild('menu') menudiv: ElementRef;

  // chart data starts

  chartdatanew: any;
  ripcolor: any = '';
  @ViewChild('styleCardref') styleCardref;

  // team data
  teamDataObjFiltered: any[] = [];

  x;
  y;

  isChecked: boolean = false;
  eventCheck: any;
  statusCheck: any;
  popY: any;
  taskY: any;
  isMenuOpen = false;

  constructor(private renderer: Renderer2) {}

  toggleMenu(status, el) {
    console.log(this.isMenuOpen, el);
    this.showMore(status, el);
    this.isMenuOpen = !this.isMenuOpen;
    console.log(this.isMenuOpen);
  }

  onClick(_status) {
    //   status.isChecked = !status.isChecked;
    //   console.log("Completed", status.isChecked);
    //   this.statusEvent.emit(status.isChecked);
  }

  showMore(status, el) {
    this.displayToggleData(status.users);
    status.isExpanded = true;
    this.x = el.clientX;
    this.y = el.clientY;
    this.eventCheck = el;
    this.statusCheck = status;
    const popCard = document.getElementById('pop');
    this.popY = popCard.offsetTop;
    this.y = -this.taskY + this.popY - 100;
  }

  displayToggleData(data) {
    this.teamDataObjFiltered = [];
    const taskCard = document.getElementById('task');
    this.taskY = taskCard.offsetHeight;
    console.log('task data===' + JSON.stringify(data));
    if (data.length > 3) {
      for (let i = 3; i < data.length; i++) {
        this.teamDataObjFiltered.push(data[i]);
      }
    }
  }

  noShow(_status, _el) {
    this.x = null;
    this.y = null;
  }

  styleCard(): object {
    // 150 is height of card/2; not able to get height
    if (this.x && this.y) {
      return {
        position: 'absolute',
        left: 255 + 'px',
        top: this.y + 'px',
        height: 330 + 'px',
        Zindex: '1000',
      };
    } else {
      return {};
    }
  }

  showLess(status) {
    if (status) {
      status.isExpanded = false;
      this.x = null;
      this.y = null;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (event != this.eventCheck) {
      this.showLess(this.statusCheck);
    }
  }
}
